export default "__VITE_ASSET__66b806ff__"